<template>
  <div v-if="redAccount" class="terms">
    <div class="terms__wrapper">
      <div class="terms--row">
        <div class="title">{{ $t`Рассрочка на 3 мес` }}</div>
        <div class="text">0%</div>
      </div>
      <div class="terms--row">
        <div class="title">{{ $t`Лимит на покупки` }}</div>
        <div class="text">
          {{ redAccount.original_amount.toLocaleString("ru-RU") }} ₸
        </div>
      </div>
      <div class="terms--row">
        <div class="title">{{ $t`Бонусы за покупки` }}</div>
        <div class="text">{{ $t`до 10%` }}</div>
      </div>
      <div v-if="!redAccount.is_new_client" class="isNotNewClient">
        <div class="terms--row">
          <div class="title">{{ $t`Клубный взнос:` }}</div>
          <div class="text">0 ₸</div>
        </div>
      </div>
      <div v-else class="isNotNewClient">
        <div class="terms--row">
          <div class="title">{{ $t`Клубный взнос:` }}</div>
          <div class="text">0 ₸</div>
        </div>
      </div>
      <div class="terms--row">
        <div class="title">{{ $t`Дата оплаты счета` }}</div>
        <div class="text">{{ redAccount.payment_day }} {{ $t`число` }}</div>
      </div>
      <div class="terms--row">
        <div class="title">{{ $t`Штраф за просроченный счет` }}</div>
        <div class="text">2 000 ₸</div>
      </div>
    </div>
    <div class="info_block">
      <span
        class="info_block__right"
        v-html="
          $t`Ответы на все вопросы о клубе Kaspi Red, вы также можете найти <a href=\&quot;https:\/\/kaspi.kz\/guide\/red\/\&quot; class=\&quot;link-to-gid__anchor\&quot;>здесь<\/a>.`
        "
      >
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.terms {
  font-family: "Roboto-Regular";
  font-size: 17px;
  width: 100%;
  height: 100%;
  color: #4a4a4a;
  &__wrapper {
    background-color: #fff;
    padding-left: 15px;
    padding-right: 15px;
    min-height: 100%;
  }

  &--row {
    display: flex;
    justify-content: space-between;
    padding-top: 17px;
    padding-bottom: 17px;
    border-bottom: 1px solid #f0f0f0;
    .title {
      width: 64vw;
      text-align: left;
    }
  }

  &--desc {
    display: flex;
    justify-content: space-between;
    padding-top: 17px;
    padding-bottom: 17px;
    margin-left: 17px;
    border-bottom: 1px solid #f0f0f0;
    .title {
      font-size: 13.5px;
    }
  }

  &--guide {
    display: flex;
    justify-content: space-between;
    margin-top: 2.67vw;
    background-color: #fff;
  }
}
.info_block {
  display: flex;
  overflow: hidden;
  padding: 13px 15px;
  background: #fff;
  min-height: 71px;
  border: 0;
  margin-top: 10px;
  align-items: center;
  text-align: left;
  &__right {
    line-height: 1.2;
  }
}
</style>

<style lang="scss">
.link-to-gid__anchor {
  color: #0089d0;
  text-decoration: none;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Conditions",
  data() {
    return {
      conditions: [],
    };
  },
  methods: {
    ...mapActions("bundle", ["fetchBundle"]),
  },
  computed: {
    ...mapGetters("bundle", ["getRedAccounts"]),
    redAccount: function () {
      if (this.getRedAccounts && this.getRedAccounts.length) {
        return this.getRedAccounts[0];
      }
      return null;
    },
  },
  mounted() {
    this.fetchBundle();
    this.$logAnalyticEvent("mybank_red_about", {
      page_path: "/bank/red/conditions",
    });
  },
};
</script>
